export default "__VITE_ASSET__Bw$NCLEE__"